

export default class Produit {

  constructor(code, libelle, audienceLibelle, pressions=[100], semainesIndispo=[]) {
    this.code = code;
    this.libelle = libelle;
    this.audienceLibelle = audienceLibelle;
    this.pressions = pressions;
    this.semainesIndispo = semainesIndispo;
  }

  tarif(semaine, format=30, pression=100) {
    return 0;
  }

  audience(semaine, pression=100) {
    return 0;
  }

  isPressionsMultiples() {
    return this.pressions.length > 1;
  }

  isDisponible(semaine) {
    return !this.semainesIndispo.includes(semaine.code);
  }
}